<template>
  <div class="d-inline float-right">
    <div class="settings-wrapper">
      <b-button class="p-1 edit-btn-sm edit-btn-blue" @click="exportWidget('XLSX')" v-b-popover.hover.top="'Download XLSX'">
        <i ref='wXLSXButton' class="fa fa-file-excel-o" aria-hidden="true"></i>
      </b-button>
      <b-button class="p-1 edit-btn-sm edit-btn-blue" @click="exportWidget('PDF')" v-b-popover.hover.top="'Download PDF'">
        <i ref='wPDFButton' class="fa" :class="pdfButtonClass" aria-hidden="true"></i>
      </b-button>
    </div>
    <div v-if="currentUser.isDigital && visible" class="d-inline float-right">
      <template v-if="showWidgetSettings">
        <b-button @click="settingsVisible=!settingsVisible" class="btn-light side-padding widget-btn">
          <i class="fa fa-cog" aria-hidden="true"></i>
        </b-button>
        <div v-if="settingsVisible" class="settings-wrapper">
          <b-button v-if='this.$parent.widget.shared' @click="deleteWidget('true')" class="modal-btn">Remove from this Dashboard</b-button>
          <b-button v-else @click="deleteWidget('false')" class="modal-btn">Delete</b-button>
          <b-button @click='clone' class="modal-btn">Clone</b-button>
          <b-button @click='edit' class="modal-btn">Edit</b-button>
        </div>
      </template>
      <i v-else class="fa fa-lock" aria-hidden="true"></i>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'SettingsButton',
  data () {
    return {
      settingsVisible: false,
      pdfButtonClass: 'fa-file-pdf-o'
    }
  },

  computed: {
    ...mapGetters(['currentUser', 'dashboard', 'dashboardData']),
    visible () {
      return this.$store.getters.widgetSettingsVisible
    },
    showWidgetSettings () {
      var widget = this.$parent
      var authorized = false

      if ((!this.dashboard.locked && !widget.locked) || this.currentUser.isAdmin || this.currentUser.id === widget.ownerId) {
        authorized = true
      }
      return authorized
    }
  },

  methods: {

    exportWidget(type) {
      let exportInfo = {
        widgetID: this.$parent.id,
        exportType: type
      }
      this.$eventBus.$emit('exportWidget', exportInfo)
    },

    deleteWidget (shared) {
      this.$parent.deleteWidget(shared)
    },

    edit () {
      var widget = this.$parent
      this.$eventBus.$emit('editWidget', widget)
    },

    clone () {
      var widget = this.$parent
      widget.makeClone = true
      this.$eventBus.$emit('editWidget', widget)
    }

  }
}
</script>
<style>
  .modal-open {
    overflow: hidden;
    overflow-y: scroll;
    padding-right: 0 !important;
  }
  .side-padding {
    padding: 0 10px;
    background: transparent;
    font-size: 1rem;
    border-color: transparent !important;
    border: none !important;
  }
  .side-padding:hover, .side-padding:active, .side-padding:focus {
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    border-color: transparent !important;
  }
  .modal-btn, .btn-primary {
    color:#fff;
    background:#3493B2;
    border: 1px solid #3493B2;
    -webkit-transition: all 0.3s ease;
		-moz-transition: all 0.3s ease;
		-o-transition: all 0.3s ease;
		transition: all .3s ease;
  }
  .modal-btn {
    padding: 3px 15px;
    margin: auto 8px;
  }
  .modal-btn:hover, .btn-primary:hover {
    background: #47889c;
    color: #fff;
    border: 1px solid #47889c;
  }
  .navbar-toggler {
    margin-right: 0 !important;
  }
  .widget-btn:hover {
    color: #47889c;
  }
  .settings-wrapper {
    float: left;
    position: relative;
    top: -5px;
  }
  .settings-wrapper button {
    margin-left: 5px;
    float: right;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", 'Roboto', "Helvetica Neue", Arial, sans-serif;
  }
  .card .edit-btn {
  color: #23282c;
  background: transparent;
  font-size: 24px;
  padding: 0px 5px;
  margin-left: -15px;
  border: none;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", 'Roboto', "Helvetica Neue", Arial, sans-serif;
}
.edit-btn-blue {
  color: #3493B2;
  background: transparent;
  border: none;
}
.edit-btn-sm {
  padding: 0px;
  font-size: 24px;
  margin-left: 15px;
  line-height: 24px;
}
.edit-btn-blue:hover {
  color: #47889c;
}
.edit-btn:hover, .edit-btn:focus, .edit-btn:active, .edit-btn-sm:hover, .edit-btn-sm:focus, .edit-btn-sm:active {
  background: transparent !important;
  box-shadow: none !important;
}

@media print {
  .settings-wrapper {
    display: none !important;
  }
}

</style>
